<div class="size-selector">
  <div class="size-selector__sizes">
    <!-- SIZE 1 -->
    <div
      class="size-selector__sizes__size"
      *ngIf="availableSizes?.[1] as extraSmall"
      data-testid="size-selector-extra-small"
      [ngClass]="
        extraSmall.selected ? 'selected' : extraSmall.spaces?.length > 0 ? 'enabled' : 'disabled'
      "
    >
      <label data-testid="available-count">{{ extraSmall.spaces?.length || 0 }}</label>
      <svg
        width="94"
        height="49"
        viewBox="0 0 94 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        (click)="selectSize(extraSmall)"
        id="extra-small"
      >
        <rect
          x="2"
          y="2"
          width="89.738"
          height="36.291"
          rx="3.299"
          stroke="#DDD"
          stroke-width="3.959"
        />
        <path
          d="M2 5.778A3.3 3.3 0 0 1 5.744 2.51l68.623 9.33a3.3 3.3 0 0 1 2.854 3.27V44.74a3.3 3.3 0 0 1-3.743 3.27L4.855 38.68A3.3 3.3 0 0 1 2 35.41V5.778z"
          fill="#DDD"
          stroke="#DDD"
        />
      </svg>

      <p>{{ extraSmall.label | translate }}</p>
    </div>

    <!-- SIZE 2 -->
    <div
      class="size-selector__sizes__size"
      *ngIf="availableSizes?.[2] as small"
      data-testid="size-selector-small"
      [ngClass]="small.selected ? 'selected' : small.spaces?.length > 0 ? 'enabled' : 'disabled'"
    >
      <label data-testid="available-count">{{ small.spaces?.length || 0 }}</label>

      <svg
        width="94"
        height="65"
        viewBox="0 0 94 65"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        (click)="selectSize(small)"
      >
        <rect
          x="2"
          y="2.955"
          width="89.738"
          height="49.488"
          rx="3.299"
          stroke="#DDD"
          stroke-width="3.959"
        />
        <path
          d="M2 6.754a3.3 3.3 0 0 1 3.762-3.267l67.963 9.623a3.3 3.3 0 0 1 2.836 3.267V59.2a3.3 3.3 0 0 1-3.761 3.267L4.837 52.844A3.3 3.3 0 0 1 2 49.577V6.754z"
          fill="#DDD"
          stroke="#DDD"
        />
      </svg>

      <p>{{ small.label | translate }}</p>
    </div>

    <!-- SIZE 3 -->
    <div
      class="size-selector__sizes__size"
      *ngIf="availableSizes?.[3] as medium"
      data-testid="size-selector-medium"
      [ngClass]="medium.selected ? 'selected' : medium.spaces?.length > 0 ? 'enabled' : 'disabled'"
    >
      <label data-testid="available-count">{{ medium.spaces?.length || 0 }}</label>
      <svg
        width="94"
        height="78"
        viewBox="0 0 94 78"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        (click)="selectSize(medium)"
      >
        <rect
          x="2"
          y="2.098"
          width="89.738"
          height="62.684"
          rx="3.299"
          stroke="#DDD"
          stroke-width="3.959"
        />
        <path
          d="M2 5.914a3.3 3.3 0 0 1 3.776-3.265l67.963 9.924a3.3 3.3 0 0 1 2.822 3.265v56.016a3.3 3.3 0 0 1-3.776 3.264L4.823 65.195A3.3 3.3 0 0 1 2 61.93V5.914z"
          fill="#DDD"
          stroke="#DDD"
          stroke-width="3.959"
        />
      </svg>
      <p>{{ medium.label | translate }}</p>
    </div>

    <!-- SIZE 4 -->
    <div
      class="size-selector__sizes__size"
      *ngIf="availableSizes?.[4] as large"
      data-testid="size-selector-large"
      [ngClass]="large.selected ? 'selected' : large.spaces?.length > 0 ? 'enabled' : 'disabled'"
    >
      <label data-testid="available-count">{{ large.spaces?.length || 0 }}</label>
      <svg
        width="94"
        height="90"
        viewBox="0 0 94 90"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        (click)="selectSize(large)"
      >
        <rect
          x="2"
          y="2.221"
          width="89.738"
          height="75.881"
          rx="3.299"
          stroke="#DDD"
          stroke-width="3.959"
        />
        <path
          d="M2 5.975a3.3 3.3 0 0 1 3.723-3.272l67.303 8.713a3.3 3.3 0 0 1 2.876 3.272v69.228a3.3 3.3 0 0 1-3.723 3.272L4.876 78.475A3.3 3.3 0 0 1 2 75.203V5.975z"
          fill="#DDD"
          stroke="#DDD"
          stroke-width="3.959"
        />
      </svg>
      <p>{{ large.label | translate }}</p>
    </div>

    <!-- SIZE 5 -->
    <div
      class="size-selector__sizes__size"
      *ngIf="availableSizes?.[5] as extraLarge"
      data-testid="size-selector-extra-large"
      [ngClass]="
        extraLarge.selected ? 'selected' : extraLarge.spaces?.length > 0 ? 'enabled' : 'disabled'
      "
    >
      <label data-testid="available-count">{{ extraLarge.spaces?.length || 0 }}</label>
      <svg
        width="94"
        height="113"
        viewBox="0 0 94 113"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        (click)="selectSize(extraLarge)"
      >
        <rect
          x="2"
          y="2.127"
          width="89.738"
          height="96.682"
          rx="3.299"
          stroke="#DDD"
          stroke-width="3.959"
        />
        <path
          d="M2 6.015A3.3 3.3 0 0 1 5.836 2.76L73.14 13.862a3.3 3.3 0 0 1 2.763 3.255v89.995a3.298 3.298 0 0 1-3.837 3.255L4.762 99.265A3.3 3.3 0 0 1 2 96.01V6.015z"
          fill="#DDD"
          stroke="#DDD"
          stroke-width="3.959"
        />
      </svg>
      <p>{{ extraLarge.label | translate }}</p>
    </div>

    <!-- SIZE 6 -->
    <div
      class="size-selector__sizes__size"
      *ngIf="availableSizes?.[6] as XXLarge"
      data-testid="size-selector-xxl"
      [ngClass]="
        XXLarge.selected ? 'selected' : XXLarge.spaces?.length > 0 ? 'enabled' : 'disabled'
      "
    >
      <label data-testid="available-count">{{ XXLarge.spaces?.length || 0 }}</label>
      <svg
        width="122"
        height="113"
        viewBox="0 0 122 113"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        (click)="selectSize(XXLarge)"
      >
        <rect
          x="2"
          y="2.127"
          width="117.451"
          height="96.682"
          rx="3.299"
          stroke="#DDD"
          stroke-width="3.959"
        />
        <path
          d="M2 5.869a3.3 3.3 0 0 1 3.712-3.274l90.125 11.359a3.3 3.3 0 0 1 2.887 3.273v90.032a3.298 3.298 0 0 1-3.712 3.273L4.887 99.174A3.3 3.3 0 0 1 2 95.9V5.87z"
          fill="#DDD"
          stroke="#DDD"
          stroke-width="3.959"
        />
      </svg>
      <p>{{ XXLarge.label | translate }}</p>
    </div>

    <!-- SIZE 7 -->
    <div
      class="size-selector__sizes__size"
      *ngIf="availableSizes?.[7] as cage"
      data-testid="size-selector-cage"
      [ngClass]="cage.selected ? 'selected' : cage.spaces?.length > 0 ? 'enabled' : 'disabled'"
    >
      <label data-testid="available-count">{{ cage.spaces?.length || 0 }}</label>
      <svg
        width="97"
        height="165"
        viewBox="0 0 97 165"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        (click)="selectSize(cage)"
      >
        <rect
          x="2"
          y="2.221"
          width="89.738"
          height="148.682"
          rx="3.299"
          stroke="#DDD"
          stroke-width="3.959"
        />
        <path
          d="M2.062 6.012a3.3 3.3 0 0 1 3.886-3.297L72.2 14.705a3.3 3.3 0 0 1 2.712 3.247v140.871a3.3 3.3 0 0 1-3.802 3.261l-64.048-9.877a3.299 3.299 0 0 1-2.796-3.21L2.062 6.012z"
          fill="#DDD"
          stroke="#DDD"
          stroke-width="3.959"
        />
      </svg>
      <p>{{ cage.label | translate }}</p>
    </div>
  </div>
</div>
